import { BoxesApiRemoteService } from '../../Services/api/boxes/boxes-service'
import { IBoxEntity } from '../../Services/api/boxes/boxes.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowBoxesUseCase
implements IFormUsecase<string, IBoxEntity | undefined> {
  constructor (private readonly BoxesApi: BoxesApiRemoteService) {}
    

  public async handle (
    boxId: string
  ): Promise<Result<IBoxEntity | undefined>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.BoxesApi.show(boxId)

      if (response.isFailure) {
        return response
      }
    
      const show = response.getValue()

      if(!show) return response
    
      return Result.ok(show)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
